import clsx from 'clsx'

interface LoadingPageIconProps {
  className?: string
}

export const LoadingPageIcon = ({ className }: LoadingPageIconProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('animate-spin', className)}
    >
      <mask
        id="mask0_823_3865"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 4.5C18.8283 4.5 13.8684 6.55446 10.2114 10.2114C6.55446 13.8684 4.5 18.8283 4.5 24C4.5 29.1717 6.55446 34.1316 10.2114 37.7886C13.8684 41.4455 18.8283 43.5 24 43.5C29.1717 43.5 34.1316 41.4455 37.7886 37.7886C41.4455 34.1316 43.5 29.1717 43.5 24C43.5 18.8283 41.4455 13.8684 37.7886 10.2114C34.1316 6.55446 29.1717 4.5 24 4.5ZM0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24Z"
          fill="#4A90E2"
        />
      </mask>
      <g mask="url(#mask0_823_3865)">
        <rect
          x="24"
          y="-3.4324"
          width="29.1429"
          height="29.1429"
          fill="#F5F5F5"
        />
        <rect
          x="24"
          y="24.8571"
          width="29.1429"
          height="29.1429"
          fill="#2962FF"
        />
        <rect
          x="-5.14307"
          y="-4.28571"
          width="29.1429"
          height="58.2857"
          fill="#2962FF"
        />
      </g>
    </svg>
  )
}
